<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="dialogCancelThpCommon" [resizable]="false" [draggable]="('terminal-status' === popupOpr?.screenName)" class="{{errorDialog?'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}" header="{{popupErrorMessage}}"
    [(visible)]="isShowTerminalPlan" modal="true" (onHide)='cancelThpOperation()'>
    <div class="plan-locomotive-container" *ngIf='isShowTerminalPlan'>
        <div class="loco-to-plan">
            <span class="loco-icon-plan">{{locomotiveIdentifier}}</span>
            <p class="or clear">On</p>
            <!--<label class="terminal-mnemonic" *ngIf='terminalScreen'>
                <strong>{{searchTerminalMenmonic}}</strong>
                <p>{{searchTerminalCityState}}</p>
            </label>-->
            <!-- used for other screen like locomotive data -->
            <span>
                <label><strong>Terminal</strong></label>
                 <input tabindex="{{tabLevel}}"  type="text" disabled="true" value="{{locomotive.thpTerminal}}" class="p-inputfield" spellcheck="false">
            <p style='padding:5px 0 0 65px;'><span>{{getTerminalCityState(locomotive.thpTerminal)}}</span></p>
            </span>
        </div>
        <div class="place-to-plan">
            <div class="plan-locoto-train">
                <div class="shop-fuel-storage">
                    <h3>Terminal Handling Plan</h3>
                    <ul>
                        <li *ngIf="appUtilityService.isValidThpSelection(locomotive.thpTerminal)">
                            <p-radioButton [tabindex]="tabLevel + 1" name="radioButtonTerminalHandling" value="S" label="Service Ctr / Shop" [(ngModel)]="thpPlan" labelStyleClass="radio-btn-lable"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton [tabindex]="tabLevel + 2" name="radioButtonTerminalHandling" value="T" label="Truck Fueling" [(ngModel)]="thpPlan" labelStyleClass="radio-btn-lable"></p-radioButton>
                        </li>
                        <li>
                            <p-radioButton [tabindex]="tabLevel + 3" name="radioButtonTerminalHandling" value="M" label="Main Track" [(ngModel)]="thpPlan" labelStyleClass="radio-btn-lable"></p-radioButton>
                        </li>
                        <li *ngIf="user && user.isUserManagerOrDirector">
                            <p-radioButton [tabindex]="tabLevel + 4" name="radioButtonTerminalHandling" value="X" label="To Storage" [(ngModel)]="thpPlan" labelStyleClass="radio-btn-lable"></p-radioButton>
                        </li>
                    </ul>




                </div>
            </div>
        </div>

    </div>
    <div class="dialog-buttons" *ngIf='isShowTerminalPlan && windowCode === "LWTW"'>
        <span class="pull-left">
            <button type="button" tabindex="{{tabLevel + 5}}" class="p-button-secondary"  (click)="cancelThpOperation()">Cancel</button>
        </span>
        <span class="pull-right">
            <button *ngIf="'terminal-status'===popupOpr?.screenName" tabindex="{{tabLevel + 6}}" disabled="{{!thpPlan?'disable':''}}" class="{{!thpPlan?'p-button-disabled':'p-button-secondary'}}" (click)="submitThpOperation('addToPending')">Add to Pending</button>
                   					<button type="submit"  tabindex="{{tabLevel + 7}}" disabled="{{!thpPlan?'disable':''}}" class="{{!thpPlan?'p-button-disabled':'p-button-primary'}}" id="commonThpUpdtBtn"  (click)="submitThpOperation('submit')">Submit</button>
		</span>
    </div>

    <div class="dialog-buttons" *ngIf='isShowTerminalPlan && windowCode !== "LWTW"'>
        <span class="pull-right">
                <button type="button" tabindex="{{tabLevel + 5}}" class="p-button-secondary" (click)="cancelThpOperation()">Cancel</button>
                   					<button type="submit" tabindex="{{tabLevel + 6}}" id="commonThpUpdtBtn" disabled="{{!thpPlan?'disable':''}}" class="{{!thpPlan?'p-button-disabled':'p-button-primary'}}" (click)="submitThpOperation()">Submit</button>
		</span>
    </div>
</p-dialog>
<!-- Start Cancel Locomotive Plan -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="dialogCancelLocoPlanCommon" [resizable]="false" [draggable]="('terminal-status' === popupOpr?.screenName)" class="{{errorDialog ? 'terminal-ui-popups error-dialog' : 'terminal-ui-popups standard-dialog'}}" header="{{confirmAction}}" [visible]="confirmPop && confirmMessage" (visibleChange)="confirmPop && (confirmMessage = $event)"
    modal="true" closeOnEscape="true" (onHide)='hideDialog("Cancel Locomotive Plan");'>
    <div class="generic-spacing" *ngIf='confirmPop && confirmMessage'>

        <p>{{confirmMessage}}</p>

    </div>
    <div class="dialog-buttons" *ngIf='confirmPop && confirmMessage && windowCode === "LWTW"'>
        <span class="pull-left">
            <button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)='hideDialog("Cancel Locomotive Plan");'>Cancel</button>
            </span>
        <span class="pull-right">
            	<button *ngIf="'terminal-status'===popupOpr?.screenName" tabindex="{{tabLevel + 1}}" type="button" class="p-button-secondary" (click)='confirmbtnAction("Cancel Locomotive Plan","addToPending");'>Add To Pending</button>
		<button type="submit"  tabindex="{{tabLevel + 2}}" id="commonCnclLocoPlanBtn" class="p-button-primary" (click)='confirmbtnAction("Cancel Locomotive Plan","submit")'>Submit</button>
	</span>
    </div>

    <div class="dialog-buttons" *ngIf='confirmPop && confirmMessage && windowCode !== "LWTW"'>
        <span class="pull-right">
                <button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)='hideDialog("Cancel Locomotive Plan");'>No</button>
		<button type="submit" tabindex="{{tabLevel + 1}}" id="commonCnclLocoPlanBtn" class="p-button-primary" (click)='confirmbtnAction("Cancel Locomotive Plan")'>Yes</button>
	</span>
    </div>
</p-dialog>
<!-- End Cancel Locomotive Plan -->

<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="dialogUserPrefWindow" [resizable]="false" [draggable]="false" class="{{errorDialog? 'user-profile-dialog error-dialog' : 'user-profile-dialog'}}" header="{{popupErrorMessage}}" modal="true" [(visible)]="isShowUserProfile" (onHide)='hideDialog("User Profile");'
    closeOnEscape="true">
    <lms-user-profile [initWindowCount]='initWindowCount' (popupErrorMessage)='displayPopupError($event)' (errorDialog)='isOpenErrorDialog($event);' (isShowUserProfile)='cancelUserProfilePopup($event);' *ngIf='isShowUserProfile'></lms-user-profile>
</p-dialog>

<!-- Start Yard and Local Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="dialogYardAndLocalCommon" [resizable]="false" [draggable]="false" class="terminal-ui-popups yard-local-info" header="Yard and Local" [(visible)]="yardAndLocal" modal="true" (onHide)='cancelYardAndLocalPopup($event);' closeOnEscape="true">
    <div class="dialog-container" *ngIf='yardAndLocal'>
        <span>The locomotive is allocated to Yard and Local service. Screen for Yard and Local will be available in one of the future releases.</span>
    </div>
    <div class="dialog-buttons" *ngIf='yardAndLocal'>
        <span class="pull-right">
			<button type="button"  tabindex="{{tabLevel}}" tabindex="2310" id='yardAndLocalLocoData' (click)="cancelYardAndLocalPopup($event)" class="p-button-primary">OK</button>
		</span>
    </div>
</p-dialog>
<!-- END Yard and Local Popup -->

<!-- START ALLOCATE POPUP -->
    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="allocLocoId" [resizable]="false" [draggable]="false" class="{{errorDialog? 'terminal-ui-popups plan-locomotive error-dialog':'terminal-ui-popups plan-locomotive'}}" header="{{popupErrorMessage}}" [(visible)]="allocateLocomotive" modal="true"
    (onHide)="hideDialog('allocateLocomotive');" closeOnEscape="true" (onShow)='setPageModeData("allocateSubmitBtnId", "allocLocoId"); showAllocateDialog();'>
    <div class="plan-locomotive-container" *ngIf='allocateLocomotive'>
        <div class="loco-to-plan"> <span class="loco-icon-plan" *ngFor="let loco of locomotives"> 
            {{loco.locomotiveIdentifier && appUtilityService.UIformatLocomotiveId(loco.locomotiveIdentifier)}}</span></div>
        <div class="place-to-plan">
            <div class="space-bottom label-to">to &nbsp; {{configData && configData.yardLocalLabel.allocationStation}}</div>
            <lms-autocomplete [tabindex]='tabLevel' spellcheck="false" class="p-autocomplete allocate-dialog" id="allocationStationSuggestSearch" [(ngModel)]="searchTextAllocationStation" inputStyleClass="{{searchAllocationStationError ? 'terminal-autocomplete p-inputfield-error' : 'terminal-autocomplete'}}"
                placeholder="Allocation Station" [isStation]='true' [suggestions]="filteredResults" (completeMethod)="autoCompleteForAllocationStation($event)" [minLength]="2" (onSelect)="selectValueFromStationAutoComplete(searchTextAllocationStation)" [maxlength]="6"
                (keydown.space)='$event.stopPropagation();' (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();'>
            </lms-autocomplete>
            <div class="color-red" *ngIf='searchAllocationStationError'> {{configData.messages.planInvalidAllocationStation}} </div>
            <p></p><br>
            <div class="plan-locoto-train">
                <div class="shop-fuel-storage">
                    <h3>{{configData && configData.yardLocalLabel.allocationType}}</h3>
                    <ul>
                        <li *ngIf="allocateRole && allocateRole === 'YL'">
                            <p-radioButton labelStyleClass="radio-btn-lable" [tabindex]='tabLevel+1' name="radioButtonPlanLoco" value="YL" label="{{configData && configData.yardLocalLabel.yardLocal}}" [(ngModel)]="allocationType"></p-radioButton>
                        </li>
                        <li class="indent-checkbox" *ngIf="allocateRole && allocateRole === 'YL'">
                            <p-checkbox [tabindex]='tabLevel+2' [(ngModel)]='permanentAllocation' label="{{configData && configData.yardLocalLabel.permanentAllocation}}" binary="true"></p-checkbox>
                        </li>
                        <li *ngIf="allocateRole && (allocateRole === 'YL' || allocateRole === 'MW')">
                            <p-radioButton labelStyleClass="radio-btn-lable" [tabindex]='tabLevel+3' name="radioButtonPlanLoco" value="MW" label="{{configData && configData.yardLocalLabel.mow}}" [(ngModel)]="allocationType"></p-radioButton>
                        </li>
                        <li *ngIf="allocateRole && allocateRole === 'YL'">
                            <p-radioButton labelStyleClass="radio-btn-lable" [tabindex]='tabLevel+4' name="radioButtonPlanLoco" value="SP" label="{{configData && configData.yardLocalLabel.specialAllocation}}" [(ngModel)]="allocationType"></p-radioButton>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-buttons" *ngIf='allocateLocomotive'>
        <span class="pull-right">
        <button type="button" tabindex="{{tabLevel+5}}" (click)="hideDialog('allocateLocomotive')" class="p-button-secondary">{{configData && configData.yardLocalLabel.cancel}}</button>
        <button type="submit" tabindex="{{tabLevel+6}}" id='allocateSubmitBtnId' (click)="submitAllocateLocomotive()" class="p-button-primary" >{{configData && configData.yardLocalLabel.submit}}</button>
    </span>
    </div>
    </p-dialog>
    <!-- END ALLOCATE POPUP -->

    <!-- START DE-ALLOCATE POPUP -->
    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="deallocLocoId" [resizable]="false" [draggable]="false" class="{{errorDialog ? 'error-dialog' : 'standard-dialog'}}" header="{{popupErrorMessage}}" [(visible)]="deAllocateLocomotive" modal="true" (onHide)="hideDialog('deAllocateLocomotive');"
    closeOnEscape="true" (onShow)='setPageModeData("confirmDeAllocateSubmitId","deallocLocoId")'>
    <div class="dialog-container">
        <span>{{configData && configData.messages.dellocateLocomotiveConfirmation}}</span>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
        <button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)="hideDialog('deAllocateLocomotive');">{{configData && configData.yardLocalLabel.no}}</button>
        <button type="submit" tabindex="{{tabLevel+1}}" id="confirmDeAllocateSubmitId" class="p-button-primary" (click)='submitDeallocateLocomotives()'>{{configData && configData.yardLocalLabel.yes}}</button>
        </span>
    </div>
    </p-dialog>
    <!-- END DE-ALLOCATE POPUP -->

    <!-- START PERMANENT ALLOCATION CONFIRMATION POPUP -->
    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="permAllocConfirmId" [resizable]="false" [draggable]="false" class="{{errorDialog ? 'terminal-ui-popups error-dialog' : 'terminal-ui-popups standard-dialog'}}" header="Confirmation" [(visible)]="permannentAllocDialog" modal="true" (onHide)="hideDialog('permanentAlloc');"
    closeOnEscape="true" (onShow)='setPageModeData("permAllocConfirmBtnId", "permAllocConfirmId")'>
    <div class="dialog-container">
        <span>{{permannentAllocMsg}}</span>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
        <button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)="hideDialog('permanentAlloc');">{{configData && configData.yardLocalLabel.no}}</button>
        <button type="submit" tabindex="{{tabLevel+1}}" id="permAllocConfirmBtnId" class="p-button-primary" (click)='openAllocateLocomotivePopup()'>{{configData && configData.yardLocalLabel.yes}}</button>
        </span>
    </div>
    </p-dialog>
    <!-- END PERMANENT ALLOCATION CONFIRMATION POPUP -->

    <!-- START PERMANENT ALLOCATION For DE-ALLOCATE CONFIRMATION POPUP -->
    <p-dialog transitionOptions="0ms" [baseZIndex]="1000" id="permDeallocOprId" [resizable]="false" [draggable]="false" class="{{errorDialog ? 'terminal-ui-popups error-dialog' : 'terminal-ui-popups standard-dialog'}}" header="Confirmation" [(visible)]="permannentAllocForDeallocDialog" modal="true"
    (onHide)="hideDialog('permannentAllocForDealloc');" closeOnEscape="true" (onShow)='setPageModeData("permDeallocSubmitBtnId","permDeallocOprId")'>
    <div class="dialog-container">
        <span>{{permannentAllocMsg}}</span>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
        <button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)="hideDialog('permannentAllocForDealloc');">{{configData && configData.yardLocalLabel.no}}</button>
        <button type="submit" tabindex="{{tabLevel+1}}" id="permDeallocSubmitBtnId" class="p-button-primary" (click)="openDellocateAllocateLocomotivePopup()">{{configData && configData.yardLocalLabel.yes}}</button>
        </span>
    </div>
    </p-dialog>
    <!-- END PERMANENT ALLOCATION For DE-ALLOCATE CONFIRMATION POPUP -->